var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.items, function(item, index) {
        return _c(
          "DIV",
          { key: index, staticClass: "d-flex flex-col form-row" },
          [
            _vm.items.length > 1
              ? _c("div", { staticClass: "col-auto" }, [
                  _vm._v("\n      #" + _vm._s(index + 1) + "\n    ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col" },
              [
                _c(
                  "DIV",
                  { staticClass: "mb-2" },
                  [
                    _c("ItpFormInput", {
                      attrs: {
                        name: "message",
                        required: "",
                        readonly: _vm.readonly,
                        title: _vm._f("pgettext")(
                          "The message to include to the invoice.",
                          "TransactionNotesEditor"
                        )
                      },
                      on: {
                        input: function($event) {
                          return _vm.evh_5534025912102772_input($event, {
                            item: item,
                            index: index
                          })
                        }
                      },
                      model: {
                        value: item.message,
                        callback: function($$v) {
                          _vm.$set(item, "message", $$v)
                        },
                        expression: "item.message"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("DIV", { staticClass: "form-row align-items-center" }, [
                  _c(
                    "div",
                    { staticClass: "col-3" },
                    [
                      _c("ItpFormDatetime", {
                        attrs: {
                          name: "valid_from",
                          readonly: _vm.readonly,
                          placeholder: _vm._f("pgettext")(
                            "Valid from",
                            "TransactionNotesEditor"
                          ),
                          title: _vm._f("pgettext")(
                            "Valid from",
                            "TransactionNotesEditor"
                          )
                        },
                        on: {
                          input: function($event) {
                            return _vm.evh_309515315410323_input($event, {
                              item: item,
                              index: index
                            })
                          }
                        },
                        model: {
                          value: item.valid_from,
                          callback: function($$v) {
                            _vm.$set(item, "valid_from", $$v)
                          },
                          expression: "item.valid_from"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-3" },
                    [
                      _c("ItpFormDatetime", {
                        attrs: {
                          name: "valid_to",
                          readonly: _vm.readonly,
                          placeholder: _vm._f("pgettext")(
                            "Valid to",
                            "TransactionNotesEditor"
                          ),
                          title: _vm._f("pgettext")(
                            "Valid to",
                            "TransactionNotesEditor"
                          )
                        },
                        on: {
                          input: function($event) {
                            return _vm.evh_5188750589197515_input($event, {
                              item: item,
                              index: index
                            })
                          }
                        },
                        model: {
                          value: item.valid_to,
                          callback: function($$v) {
                            _vm.$set(item, "valid_to", $$v)
                          },
                          expression: "item.valid_to"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-3" },
                    [
                      _c("ItpFormInput", {
                        attrs: {
                          name: "counter",
                          type: "number",
                          readonly: _vm.readonly,
                          placeholder: _vm._f("pgettext")(
                            "Counter",
                            "TransactionNotesEditor"
                          ),
                          title: _vm._f("pgettext")(
                            "Counter",
                            "TransactionNotesEditor"
                          )
                        },
                        on: {
                          input: function($event) {
                            return _vm.evh_3475726502813997_input($event, {
                              item: item,
                              index: index
                            })
                          }
                        },
                        model: {
                          value: item.counter,
                          callback: function($$v) {
                            _vm.$set(item, "counter", $$v)
                          },
                          expression: "item.counter"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-3" },
                    [
                      _c("ItpFormInput", {
                        attrs: {
                          name: "max_displays",
                          type: "number",
                          readonly: _vm.readonly,
                          placeholder: _vm._f("pgettext")(
                            "Max displays",
                            "TransactionNotesEditor"
                          ),
                          title: _vm._f("pgettext")(
                            "Max displays",
                            "TransactionNotesEditor"
                          )
                        },
                        on: {
                          input: function($event) {
                            return _vm.evh_4449693688767071_input($event, {
                              item: item,
                              index: index
                            })
                          }
                        },
                        model: {
                          value: item.max_displays,
                          callback: function($$v) {
                            _vm.$set(item, "max_displays", $$v)
                          },
                          expression: "item.max_displays"
                        }
                      })
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            !_vm.readonly && !_vm.disabled
              ? _c("div", { staticClass: "col-auto" }, [
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        "data-dismiss": "modal",
                        "aria-label": "Close",
                        title: _vm._f("pgettext")(
                          "Remove",
                          "TransactionNotesEditor"
                        )
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          $event.stopPropagation()
                          return _vm.evh_1548630417156826_clickPreventStop(
                            $event,
                            { item: item, index: index }
                          )
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ])
              : _vm._e()
          ]
        )
      }),
      _vm._v(" "),
      !_vm.readonly && !_vm.disabled
        ? _c(
            "DIV",
            { staticClass: "d-flex mt-2 align-items-center" },
            [
              _c(
                "DIV",
                {
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.evh_96700093353179_clickPreventStop($event, {})
                    }
                  }
                },
                [
                  _c("ItpLink", {
                    attrs: {
                      icon: _vm.$config.addIcon,
                      text: _vm._f("pgettext")("Add", "TransactionNotesEditor")
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }